import { useCallback, useEffect, useState } from 'react';

/**
 * Per-user "auto-read answers" preference, stored in localStorage keyed by
 * the authenticated user's id so a shared device never speaks under another
 * tech's preference (Codex #10). Defaults OFF.
 */
export function useVoicePreferences(userId: number | null | undefined) {
  const key = userId != null ? `voice_autoread:${userId}` : null;

  const [autoRead, setAutoReadState] = useState<boolean>(() => {
    if (!key) return false;
    return localStorage.getItem(key) === 'true';
  });

  useEffect(() => {
    setAutoReadState(key ? localStorage.getItem(key) === 'true' : false);
  }, [key]);

  const setAutoRead = useCallback(
    (value: boolean) => {
      setAutoReadState(value);
      if (key) localStorage.setItem(key, String(value));
    },
    [key],
  );

  return { autoRead, setAutoRead };
}
